// Add finalists here: { id, title, creator, category: "Laughter" | "Tears" | "Fears", thumbnail, url }
export const FILMS = [];
